<template lang="pug">
	.lesson-block.main-block
		.lesson-block__content(v-if="!isEditLocal")
			Button.-xs-(:href="currectLink" :target="content.isBlank ? '_blank' : null") {{content.buttonText}}

		.lesson-block__content(v-if="isEditLocal")
			.lesson-block__row
				Input.lesson-block__edit(
					:value="contentLocal.buttonText"
					@input="checkingBtnName"
					:error="(!$v.contentLocal.buttonText.required || !$v.contentLocal.buttonText.minLength || !$v.contentLocal.buttonText.maxLength)"
					title="Текст кнопки"
				)
					span.form-item__error(v-if="!$v.contentLocal.buttonText.required || !$v.contentLocal.buttonText.minLength")
						| Название не должно быть меньше 4 символов
					span.form-item__error(v-else-if="!$v.contentLocal.buttonText.maxLength")
						| Название не должно быть больше 25 символов


				Input.lesson-block__edit(
					v-model="contentLocal.buttonUrl"
					title="Ссылка")

			.lesson-block__buttons
				Button.-xs-(@click="saveBlock"
				:class="{'-disabled-':!$v.contentLocal.buttonText.required || !$v.contentLocal.buttonText.minLength || !$v.contentLocal.buttonText.maxLength}"
				:isLoading="isLoading") Сохранить
				ButtonCancel.-xs-.hover__link(@click="cancel") Отмена

				Checkbox(
					v-model="contentLocal.isBlank"
					text="Открыть в новой вкладке")
				Checkbox(
					v-model="contentLocal.openInAppDefaultBrowser"
					text="Открывать в дефолтном браузере в приложениях Toolbox")


		ControlsArrow.lesson__controls(
			v-if="$permissionsUpdate"
			:firstBlock="isFirstBlock"
			:lastBlock="isLastBlock"
			@moveUp="moveUp"
			@moveDown="moveDown")

		OptionsList.course-lesson__options(
			v-if="optionsFields.length"
			:optionsFields="optionsFields"
		)

</template>

<script>
import _ from 'lodash';
import blockPermissionMixin from '@/views/Courses/Lesson/components/block.permission.mixin';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';

export default {
  mixins: [blockPermissionMixin],
  props: {
    permissions: {},
    content: {},
    arrows: {
      default: true,
      type: Boolean
    },
    isEdit: {
      default: false,
      type: Boolean
    },
    isFirstBlock: {
      default: false,
      type: Boolean
    },
    isLastBlock: {
      default: false,
      type: Boolean
    },
    isLoading: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      contentLocal: {
        buttonText: ''
      },
      isEditLocal: false
    };
  },
  computed: {
    currectLink() {
      const isHref = /https:\/\//.test(this.content.buttonUrl);
      let linkEdited;

      if (isHref) {
        linkEdited = this.content.buttonUrl;
      } else {
        linkEdited = `https://${this.content.buttonUrl}`;
      }

      return linkEdited;
    },
    optionsFields() {
      const fields = [];
      if (this.$permissionsUpdate) {
        fields.push({
          text: 'Редактировать',
          func: this.openBlockEdit,
          icon: 'edit'
        });
      }
      if (this.$permissionsCreate) {
        fields.push({
          text: 'Дублировать',
          func: this.duplicateBlock,
          icon: 'copy'
        });
      }

      if (this.$permissionsDelete) {
        fields.push({
          text: 'Удалить',
          func: this.deleteBlock,
          icon: 'delete',
          iconWidth: '10px',
          confirm: true,
          confirmlink: 'Вы уверены, что хотите удалить этот блок?',
          confirmDescription: 'Блок будет удален навсегда',
          confirmApplyText: 'Удалить',
          confirmCancelText: 'Отменить',
          red: true
        });
      }

      return fields;
    }
  },
  watch: {
    isEditDefault() {
      this.isEditLocal = this.isEdit;
    },
    content() {
      this.setData();
    }
  },
  mounted() {
    this.setData();

    if (this.contentLocal.forceEdit) {
      this.isEditLocal = true;
      delete this.contentLocal.forceEdit;
    }
  },
  methods: {
    setData() {
      this.contentLocal = _.cloneDeep(this.content);
    },
    checkingBtnName(props) {
      this.contentLocal.buttonText = props;
      this.$v.contentLocal.buttonText.$touch();
    },
    openBlockEdit() {
      this.isEditLocal = true;
    },
    deleteBlock() {
      this.$emit('deleteBlock');
    },
    saveBlock() {
      setTimeout(() => {
        this.isEditLocal = false;
      }, 1000);

      this.$emit('saveBlock', this.contentLocal);
    },
    cancel() {
      this.isEditLocal = false;
      this.setData();
    },
    duplicateBlock() {
      this.$emit('duplicateBlock');
    },
    moveUp() {
      this.$emit('moveUp');
    },
    moveDown() {
      this.$emit('moveDown');
    }
  },
  validations: {
    contentLocal: {
      buttonText: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(25)
      }
    }
  }
};
</script>
